import { FlightsClassTypes, isRewardFareClass, isValidFareClassWithReward } from 'constants/flight'
import { useMaldivesDirectBundleContext } from 'components/MaldivesDirect/MaldivesDirectSearchPage/MaldivesDirectBundleContext'
import { useCharterFlightPrice } from 'hooks/useFlightPrice'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCharterBundleRoute } from 'selectors/offerPage/initialOfferPageStateSelectors'
import { isConfiguredFeederOriginAirportCode } from 'lib/charterFlights/charterBundleOfferPageUtils'
import useReturnForFreeSaleAvailability from 'hooks/CharterFlights/useReturnForFreeSaleAvailability'

const DEFAULT_ROOMS: Array<App.Occupants> = [{ adults: 2 }]

interface Params {
  offer: App.Offer | App.OfferSummary
  filters?: App.OfferListFilters
}

export default function useCharterBundleReturnFareFree({ offer, filters }: Params): boolean {
  const {
    hasUserSelectedDates,
    hasReturnFareFree: contextHasReturnFareFree,
  } = useMaldivesDirectBundleContext()

  const charterBundleRoute = useAppSelector(state => getCharterBundleRoute(state, offer))
  const filterFareClass = isValidFareClassWithReward(filters?.fareClass) ? filters.fareClass : undefined
  const effectiveSelectedFareClass = filterFareClass ?? FlightsClassTypes.ECONOMY
  const isRewardSelected = isRewardFareClass(effectiveSelectedFareClass)
  const rooms = filters?.rooms ?? DEFAULT_ROOMS
  const hasDatedCharterFilters = !!(filters?.checkIn && filters.checkOut && charterBundleRoute)

  const feederAirportCode = isConfiguredFeederOriginAirportCode(
    charterBundleRoute ?? 'melbourne-maldives',
    filters?.feederOriginAirportCode,
  )
    ? filters?.feederOriginAirportCode
    : undefined

  const { hasReturnFareFree: charterHasReturnFareFree } = useCharterFlightPrice({
    charterBundleRoute: charterBundleRoute ?? 'melbourne-maldives',
    checkInDate: filters?.checkIn,
    checkOutDate: filters?.checkOut,
    occupancies: rooms,
    fareClass: effectiveSelectedFareClass,
    disabled: !charterBundleRoute || (!isRewardSelected && !hasDatedCharterFilters),
    feederOriginAirportCode: filters?.feederOriginAirportCode,
  })

  const { isSaleEnabled } = useReturnForFreeSaleAvailability()

  const hasSelectedDates = hasUserSelectedDates || !!(filters?.checkIn && filters.checkOut)

  return hasSelectedDates &&
    (isSaleEnabled || !feederAirportCode) &&
    !!(contextHasReturnFareFree ?? charterHasReturnFareFree)
}
